'use strict';

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var debug = require('debug');

var PeerId = require('peer-id');

var drain = require('it-drain');

var _require = require('p-queue'),
    PQueue = _require.default;

var defer = require('p-defer');

var log = debug('libp2p-delegated-content-routing');
log.error = debug('libp2p-delegated-content-routing:error');
var DEFAULT_TIMEOUT = 30e3; // 30 second default

var CONCURRENT_HTTP_REQUESTS = 4;
/**
 * @typedef {import('peer-id').PeerID} PeerID
 * @typedef {import('cids').CID} CID
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 */

/**
 * An implementation of content routing, using a delegated peer.
 */

var DelegatedContentRouting = /*#__PURE__*/function () {
  /**
   * Create a new DelegatedContentRouting instance.
   *
   * @param {PeerID} peerId - the id of the node that is using this routing.
   * @param {object} client - an instance of the ipfs-http-client module
   */
  function DelegatedContentRouting(peerId, client) {
    _classCallCheck(this, DelegatedContentRouting);

    if (peerId == null) {
      throw new Error('missing self peerId');
    }

    if (client == null) {
      throw new Error('missing ipfs http client');
    }

    this._client = client;
    this.peerId = peerId; // limit concurrency to avoid request flood in web browser
    // https://github.com/libp2p/js-libp2p-delegated-content-routing/issues/12

    var concurrency = {
      concurrency: CONCURRENT_HTTP_REQUESTS
    };
    this._httpQueue = new PQueue(concurrency); // sometimes refs requests take long time, they need separate queue
    // to not suffocate regular business

    this._httpQueueRefs = new PQueue(Object.assign({}, concurrency, {
      concurrency: 2
    }));

    var _client$getEndpointCo = client.getEndpointConfig(),
        protocol = _client$getEndpointCo.protocol,
        host = _client$getEndpointCo.host,
        port = _client$getEndpointCo.port;

    log("enabled DelegatedContentRouting via ".concat(protocol, "://").concat(host, ":").concat(port));
  }
  /**
   * Search the dht for providers of the given CID.
   *
   * - call `findProviders` on the delegated node.
   *
   * @param {CID} key - The CID to find providers for
   * @param {object} options - Options
   * @param {number} options.timeout - How long the query can take. Defaults to 30 seconds
   * @param {number} options.numProviders - How many providers to find, defaults to 20
   * @returns {AsyncIterable<{ id: PeerId, multiaddrs: Multiaddr[] }>} - An async iterable of PeerId/Multiaddrs
   */


  _createClass(DelegatedContentRouting, [{
    key: "findProviders",
    value: function findProviders(key) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var providers, onStart, onFinish, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, id, addrs;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                log("findProviders starts: ".concat(key));
                options.timeout = options.timeout || DEFAULT_TIMEOUT;
                providers = 0;
                onStart = defer();
                onFinish = defer();

                _this._httpQueue.add(function () {
                  onStart.resolve();
                  return onFinish.promise;
                });

                _context.prev = 6;
                _context.next = 9;
                return _awaitAsyncGenerator(onStart.promise);

              case 9:
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context.prev = 11;
                _iterator = _asyncIterator(_this._client.dht.findProvs(key, {
                  numProviders: options.numProviders,
                  timeout: options.timeout
                }));

              case 13:
                _context.next = 15;
                return _awaitAsyncGenerator(_iterator.next());

              case 15:
                if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                  _context.next = 23;
                  break;
                }

                _step$value = _step.value, id = _step$value.id, addrs = _step$value.addrs;
                _context.next = 19;
                return {
                  id: PeerId.parse(id),
                  multiaddrs: addrs
                };

              case 19:
                providers++;

              case 20:
                _iteratorAbruptCompletion = false;
                _context.next = 13;
                break;

              case 23:
                _context.next = 29;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](11);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 29:
                _context.prev = 29;
                _context.prev = 30;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context.next = 34;
                  break;
                }

                _context.next = 34;
                return _awaitAsyncGenerator(_iterator.return());

              case 34:
                _context.prev = 34;

                if (!_didIteratorError) {
                  _context.next = 37;
                  break;
                }

                throw _iteratorError;

              case 37:
                return _context.finish(34);

              case 38:
                return _context.finish(29);

              case 39:
                _context.next = 45;
                break;

              case 41:
                _context.prev = 41;
                _context.t1 = _context["catch"](6);
                log.error('findProviders errored:', _context.t1);
                throw _context.t1;

              case 45:
                _context.prev = 45;
                onFinish.resolve();
                log("findProviders finished: ".concat(key, " found ").concat(providers, " providers"));
                return _context.finish(45);

              case 49:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 41, 45, 49], [11, 25, 29, 39], [30,, 34, 38]]);
      }))();
    }
    /**
     * Announce to the network that the delegated node can provide the given key.
     *
     * Currently this uses the following hack
     * - delegate is one of bootstrap nodes, so we are always connected to it
     * - call block stat on the delegated node, so it fetches the content
     * - call dht provide with the passed cid
     *
     * N.B. this must be called for every block in the dag you want provided otherwise
     * the delegate will only be able to supply the root block of the dag when asked
     * for the data by an interested peer.
     *
     * @param {CID} key - The delegate will publish a provider record for this CID
     * @returns {Promise<void>}
     */

  }, {
    key: "provide",
    value: function () {
      var _provide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                log("provide starts: ".concat(key));
                _context3.next = 3;
                return this._httpQueueRefs.add( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this2._client.block.stat(key);

                        case 2:
                          _context2.next = 4;
                          return drain(_this2._client.dht.provide(key));

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })));

              case 3:
                log("provide finished: ".concat(key));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function provide(_x) {
        return _provide.apply(this, arguments);
      }

      return provide;
    }()
  }]);

  return DelegatedContentRouting;
}();

module.exports = DelegatedContentRouting;